import {
  TECHNICAL_SUPPORT_REQUEST_ADDED,
  TECHNICAL_SUPPORT_REQUEST_DELETED,
  TECHNICAL_SUPPORT_REQUEST_EDITED,
  TECHNICAL_SUPPORT_REQUEST_SET,
} from 'src/app/redux/redux-types';
import { reduxTechnicalSupportRequestTypes } from 'src/types';

export const technicalSupportRequestDefaultState: reduxTechnicalSupportRequestTypes.StateType = {
  technicalSupportRequestList: [],
  isTSRFetchRequestCompleted: false,
};

export const technicalSupportRequestReducer = (
  state = technicalSupportRequestDefaultState,
  action: reduxTechnicalSupportRequestTypes.ActionType,
): reduxTechnicalSupportRequestTypes.StateType => {
  switch (action.type) {
    case TECHNICAL_SUPPORT_REQUEST_SET:
      return {
        ...state,
        technicalSupportRequestList: action.payload.list,
        isTSRFetchRequestCompleted: action.payload.isTSRFetchRequestCompleted,
      };
    case TECHNICAL_SUPPORT_REQUEST_ADDED:
      // eslint-disable-next-line no-case-declarations
      const exists = state.technicalSupportRequestList.some((item) => item.id === action.payload.id);
      if (exists) {
        return state;
      }
      return {
        ...state,
        technicalSupportRequestList: [action.payload, ...state.technicalSupportRequestList],
      };
    case TECHNICAL_SUPPORT_REQUEST_EDITED:
      // eslint-disable-next-line no-case-declarations
      const updateIndex = state.technicalSupportRequestList.findIndex((obj) => obj.id === action.payload.id);
      return {
        ...state,
        technicalSupportRequestList: [
          ...state.technicalSupportRequestList.slice(0, updateIndex),
          action.payload,
          ...state.technicalSupportRequestList.slice(updateIndex + 1),
        ],
      };
    case TECHNICAL_SUPPORT_REQUEST_DELETED:
      return {
        ...state,
        technicalSupportRequestList: state.technicalSupportRequestList.filter((o) => o.id !== action.payload),
      };
    default:
      return state;
  }
};
